<div class="app-page-wrapper">
  <div class="flex-container" *ngIf="ready">
    <app-search [hidden]="!searching" [products]="products"></app-search>
    <app-header></app-header>
    <main class="flex-content offset-nav" id="uu-skip-target" role="main" tabindex="-1">
        <app-uss-page-alert></app-uss-page-alert>
        <router-outlet (activate)="onActivate()"></router-outlet>
    </main>
    <app-footer></app-footer>
  </div>
</div>
